import React, { useEffect, useRef, useState } from "react";
import NovoEventoService from "../../services/Eventos/NovoEventoService";
import InscricaoService from "../../services/Inscricoes/InscricaoService";
import ChartInscricoes from "./ChartInscricoes";
import ChartMeioPagamento from "./ChartMeioPagamento";
import Voucher from "../financeiro/Voucher";
import AdicionarLote from "./AdicionarLote";
import GerenciarCoOrganizadores from "./GerenciarCoOrganizadores";
import UploadTrajetoMaps from "../mapa/UploadTrajetoMaps";
import { formatDateBR } from "../../utils/dateUtils";
import { isFaixaEtaria60Mais, calcularValorComDesconto60Mais } from "../../utils/loteUtils";
import escudoVerde from "../../statics/img/escudo-verde.png";
import { Button, Input, Textarea, Modal, Toast, Badge, Spinner, Checkbox } from "../ui";
import {
    Calendar,
    MapPin,
    Pencil,
    Eye,
    Users,
    Mail,
    Gift,
    CheckCircle2,
    ChevronDown,
    ChevronUp,
    FileSpreadsheet,
    Search,
    Trash2,
    Upload,
    Ticket,
    Send,
    ChevronLeft,
    ChevronRight,
    ChevronsLeft,
    ChevronsRight,
    Loader2,
    Tag,
    Award,
    Plus,
    X
} from "lucide-react";

function ListaEventos() {
    const eventoService = new NovoEventoService();
    const incricaoService = new InscricaoService();
    const toast = useRef(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filtroStatus, setFiltroStatus] = useState('todos');
    const [expandedCards, setExpandedCards] = useState({});

    const toggleCardActions = (corridaId) => {
        setExpandedCards(prev => ({
            ...prev,
            [corridaId]: !prev[corridaId]
        }));
    };

    const getStatusCategory = (status) => {
        const s = String(status || '').toLowerCase().trim();
        if (s.includes('abert')) return 'abertas';
        if (s.includes('encerrad') || s.includes('fechad')) return 'encerradas';
        if (s.includes('finaliz') || s.includes('concl')) return 'finalizados';
        return 'outros';
    };

    const usuarioLogadoId = Number(sessionStorage.getItem('brv-user-id'));

    const [data, setData] = useState([]);
    const [aCarregar, setACarregar] = useState(true);
    const [productDialog, setProductDialog] = useState(false);
    const [incricoes, setIncricoes] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loadingInscricoes, setLoadingInscricoes] = useState(false);
    const [lazyParams, setLazyParams] = useState({ first: 0, rows: 15, page: 0 });
    const [exportandoExcel, setExportandoExcel] = useState(false);
    const searchTimeoutRef = useRef(null);
    const [selectedInscricoes, setSelectedInscricoes] = useState([]);
    const [countInscricoes, setCountInscricoes] = useState({});
    const [countMeiosPagamento, setCountMeiosPagamento] = useState({});
    const [dados, setDados] = useState(null);
    const [lotes, setLotes] = useState([]);
    const [dialogVoucher, setDialogVoucher] = useState(false);
    const [voucherCorridaId, setVoucherCorridaId] = useState(null);
    const [dialogEmail, setDialogEmail] = useState(false);
    const [corridaEmail, setCorridaEmail] = useState(null);
    const [emailSubject, setEmailSubject] = useState('');
    const [emailMessage, setEmailMessage] = useState('');
    const [enviandoEmail, setEnviandoEmail] = useState(false);
    const [dialogExcluirLote, setDialogExcluirLote] = useState(false);
    const [loteParaExcluir, setLoteParaExcluir] = useState(null);
    const [excluindoLote, setExcluindoLote] = useState(false);
    const [dialogExcluirInscricao, setDialogExcluirInscricao] = useState(false);
    const [inscricaoParaExcluir, setInscricaoParaExcluir] = useState(null);
    const [excluindoInscricao, setExcluindoInscricao] = useState(false);
    const [dialogEquipe, setDialogEquipe] = useState(false);
    const [corridaEquipe, setCorridaEquipe] = useState(null);

    // Inscrição Direta
    const [dialogInscricaoDireta, setDialogInscricaoDireta] = useState(false);
    const [emailBusca, setEmailBusca] = useState('');
    const [buscandoCorredor, setBuscandoCorredor] = useState(false);
    const [corredorEncontrado, setCorredorEncontrado] = useState(null);
    const [erroBusca, setErroBusca] = useState('');
    const [categoriaSelecionadaId, setCategoriaSelecionadaId] = useState('');
    const [tamanhoBlusaDireta, setTamanhoBlusaDireta] = useState('');
    const [equipeDireta, setEquipeDireta] = useState('');
    const [metodoPagamentoDireta, setMetodoPagamentoDireta] = useState('PIX');
    const [uuidPagamentoDireta, setUuidPagamentoDireta] = useState('');
    const [valorPagamentoDireta, setValorPagamentoDireta] = useState('');
    const [realizandoInscricao, setRealizandoInscricao] = useState(false);
    const [categoriasEvento, setCategoriasEvento] = useState([]);

    // Edição
    const [dialogEditar, setDialogEditar] = useState(false);
    const [editFormData, setEditFormData] = useState({
        nome_corrida: '',
        data_evento: '',
        hora_inicio_evento: '',
        inicio_inscricao: '',
        fim_inscricao: '',
        dt_entrega_kit: '',
        cidade_evento: '',
        uf: '',
        tamanho_percurso: '',
        trajeto: '',
        qtd_vagas: ''
    });
    const [novaImagem, setNovaImagem] = useState(null);
    const [previewImagem, setPreviewImagem] = useState(null);
    const [salvandoEdicao, setSalvandoEdicao] = useState(false);
    const bannerInputRef = useRef(null);

    // Categorias na Edição
    const [categoriasEdicao, setCategoriasEdicao] = useState([]);
    const [carregandoCategoriasEdicao, setCarregandoCategoriasEdicao] = useState(false);
    const [novaCategoriaNome, setNovaCategoriaNome] = useState('');
    const [novaCategoriaFaixa, setNovaCategoriaFaixa] = useState('');
    const [salvandoCategoria, setSalvandoCategoria] = useState(false);
    const [editandoCategoriaId, setEditandoCategoriaId] = useState(null);
    const [editandoCategoriaNome, setEditandoCategoriaNome] = useState('');
    const [editandoCategoriaFaixa, setEditandoCategoriaFaixa] = useState('');

    const formatDate = (value) => formatDateBR(value);

    const getCorridaId = (product) => {
        if (!product) return null;
        return product.id_corrida ?? product.id ?? null;
    };

    const getInscricaoId = (item) => {
        if (!item) return null;
        return item.id ?? item.id_inscricao ?? item.id_requisicao ?? null;
    };

    const isInscricaoPendente = (item) => {
        if (!item || !item.status) return false;
        const s = String(item.status).toLowerCase().trim();
        return s !== 'inscrito' && (s.includes('aguardando') || s.includes('pendente'));
    };

    const isProprietarioCorrida = (corrida) => {
        if (!corrida) return false;
        if (corrida.id_usuario && Number(corrida.id_usuario) === usuarioLogadoId) return true;
        if (corrida.usuario && Number(corrida.usuario) === usuarioLogadoId) return true;
        if (corrida.organizador_id && Number(corrida.organizador_id) === usuarioLogadoId) return true;
        if (corrida.eh_proprietario !== undefined) return Boolean(corrida.eh_proprietario);
        return true;
    };

    const handlePatchKitEntregue = async (item, isEntregue) => {
        const inscricaoId = getInscricaoId(item);
        if (!inscricaoId) {
            console.error("ID da inscrição não encontrado para atualização do kit.");
            return;
        }

        const payload = JSON.stringify({ kit_is_entregue: isEntregue });

        try {
            const response = await incricaoService.patchInscricao(inscricaoId, payload);

            if (response.ok || response.status === 200 || response.status === 204) {
                setIncricoes(prev =>
                    prev.map(inc =>
                        getInscricaoId(inc) === inscricaoId ? { ...inc, kit_is_entregue: isEntregue } : inc
                    )
                );
                setSelectedInscricoes(prev => {
                    if (isEntregue) {
                        return [...prev, item];
                    } else {
                        return prev.filter(i => getInscricaoId(i) !== inscricaoId);
                    }
                });
                toast.current?.show({
                    severity: 'success',
                    summary: 'Sucesso!',
                    detail: `Kit ${isEntregue ? 'entregue' : 'marcado como não entregue'} com sucesso!`,
                    life: 3000
                });
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro!',
                    detail: 'Erro ao atualizar entrega do kit.',
                    life: 3000
                });
            }
        } catch (error) {
            console.error("Erro no patch do kit_is_entregue:", error);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro!',
                detail: 'Erro de comunicação ao atualizar entrega do kit.',
                life: 3000
            });
        }
    };

    const handleSetLiberarEvento = async (dataStatus, id) => {
        const agora = new Date();
        const year = agora.getFullYear();
        const month = String(agora.getMonth() + 1).padStart(2, '0');
        const day = String(agora.getDate()).padStart(2, '0');
        const hojeStr = `${year}-${month}-${day}`;

        let dat = {
            'status_evento': dataStatus
        };
        if (dataStatus === "Inscrição Aberta") {
            dat.inicio_inscricao = hojeStr;
        }

        const response = await eventoService.setUpdateStatusEvento(JSON.stringify(dat), id);
        if (response.status === 200) {
            if (dataStatus === "Inscrição Aberta") {
                try {
                    const resLotes = await eventoService.getLotesPorCorrida(id);
                    if (resLotes.ok) {
                        const lotesList = await resLotes.json();
                        if (Array.isArray(lotesList) && lotesList.length > 0) {
                            const lotesOrdenados = [...lotesList].sort((a, b) => (a.ordem || 1) - (b.ordem || 1));
                            const primeiroLote = lotesOrdenados[0];
                            const payloadLote = {
                                ativo: true,
                                data_inicio: hojeStr
                            };
                            await eventoService.updateLote(primeiroLote.id, payloadLote);
                        }
                    }
                } catch (err) {
                    console.error("Erro ao liberar primeiro lote:", err);
                }
            }

            setData(prevData =>
                prevData.map(ev => getCorridaId(ev) === id ? { ...ev, status_evento: dataStatus } : ev)
            );

            if (dados && getCorridaId(dados) === id) {
                setDados(prev => prev ? { ...prev, status_evento: dataStatus } : prev);
                eventoService.getLotesPorCorrida(id)
                    .then(res => res.ok ? res.json() : [])
                    .then(lts => {
                        if (Array.isArray(lts)) {
                            setLotes(lts);
                            const loteAtivoAtual = lts.find(l => l.esta_ativo && (l.vagas_disponiveis === undefined || l.vagas_disponiveis === null || l.vagas_disponiveis > 0));
                            setDados(prev => prev ? { ...prev, lotes: lts, lote_ativo: loteAtivoAtual || null } : prev);
                        }
                    });
            }

            toast.current?.show({
                severity: 'success',
                summary: 'Sucesso!',
                detail: dataStatus === "Inscrição Aberta" 
                    ? 'Inscrições abertas e 1º lote liberado com sucesso!' 
                    : 'Status atualizado com sucesso!',
                life: 3000
            });
        }
    };

    const buscaEventos = async () => {
        try {
            const response = await eventoService.getEventoPorOrganizador(sessionStorage.getItem('brv-user-id'));
            if (!response.ok) {
                throw new Error(`Erro de HTTP: ${response.status}`);
            }
            const dat = await response.json();
            setData(Array.isArray(dat) ? dat : []);
        } catch (error) {
            console.error(error);
        } finally {
            setACarregar(false);
        }
    };

    useEffect(() => {
        buscaEventos();
    }, []);



    const carregarInscricoes = async (corridaId, page = 1, rows = 15, search = '') => {
        if (!corridaId) return;
        setLoadingInscricoes(true);
        try {
            const response = await incricaoService.getInscricaoPerCorrida(parseInt(corridaId), page, rows, search);
            if (response.ok) {
                const dat = await response.json();
                const total = typeof dat.count === 'number' ? dat.count : (Array.isArray(dat) ? dat.length : 0);
                const results = Array.isArray(dat) ? dat : (Array.isArray(dat.results) ? dat.results : []);

                const processedData = results.map(item => ({
                    ...item,
                    id: getInscricaoId(item)
                }));
                setIncricoes(processedData);
                setTotalRecords(total);

                const jaEntregues = processedData.filter(item => {
                    const val = item.kit_is_entregue;
                    return val === true || val === 'true' || val === 'True' || val === 1;
                });
                setSelectedInscricoes(jaEntregues);
            }
        } catch (error) {
            console.error("Erro ao carregar inscrições:", error);
        } finally {
            setLoadingInscricoes(false);
        }
    };

    const onPage = (event) => {
        setLazyParams(event);
        const corridaId = getCorridaId(dados);
        const currentPage = (event.page !== undefined ? event.page : Math.floor(event.first / event.rows)) + 1;
        carregarInscricoes(corridaId, currentPage, event.rows, globalFilterValue);
    };

    const editProduct = async (product) => {
        setDados({ ...product });
        const corridaId = getCorridaId(product);
        if (!corridaId) {
            console.error("ID da corrida não encontrado.");
            setLotes(Array.isArray(product.lotes) ? product.lotes : []);
            setProductDialog(true);
            return;
        }

        const initialLazyParams = { first: 0, rows: 15, page: 0 };
        setLazyParams(initialLazyParams);
        setGlobalFilterValue('');

        try {
            await carregarInscricoes(corridaId, 1, 15, '');

            try {
                const responseLotes = await eventoService.getLotesPorCorrida(corridaId);
                if (responseLotes.ok) {
                    const lts = await responseLotes.json();
                    if (Array.isArray(lts)) {
                        setLotes(lts);
                        const loteAtivo = lts.find(l => l.esta_ativo && (l.vagas_disponiveis === undefined || l.vagas_disponiveis === null || l.vagas_disponiveis > 0));
                        setDados(prev => prev ? { ...prev, lotes: lts, lote_ativo: loteAtivo || null } : prev);
                    }
                }
            } catch (errLotes) {
                console.error("Erro ao buscar lotes atualizados:", errLotes);
                setLotes(Array.isArray(product.lotes) ? product.lotes : []);
            }

            try {
                const responseCount = await incricaoService.getCountInscricoesPerCorrida(corridaId);
                const countDat = await responseCount.json();
                setCountInscricoes(countDat || {});
            } catch (e) {
                console.log(e);
            }

            try {
                const responseMeios = await incricaoService.getCountMeioPagamentoPerCorrida(corridaId);
                const meiosDat = await responseMeios.json();
                setCountMeiosPagamento(meiosDat || {});
            } catch (e) {
                console.log(e);
            }

            setProductDialog(true);
        } catch (error) {
            console.error("Erro ao abrir gerenciador:", error);
            setProductDialog(true);
        }
    };

    const recarregarLotesCorrida = async () => {
        const corridaId = getCorridaId(dados);
        if (!corridaId) return;

        try {
            const responseLotes = await eventoService.getLotesPorCorrida(corridaId);
            if (responseLotes.ok) {
                const lts = await responseLotes.json();
                if (Array.isArray(lts)) {
                    setLotes(lts);
                    const loteAtivo = lts.find(l => l.esta_ativo && (l.vagas_disponiveis === undefined || l.vagas_disponiveis === null || l.vagas_disponiveis > 0));
                    setDados(prev => prev ? { ...prev, lotes: lts, lote_ativo: loteAtivo || null } : prev);
                    setData(prevData =>
                        prevData.map(ev => getCorridaId(ev) === corridaId ? { ...ev, lotes: lts, lote_ativo: loteAtivo || null } : ev)
                    );
                }
            }
        } catch (err) {
            console.error("Erro ao recarregar lotes:", err);
        }
    };

    const handleToggleAtivoLote = async (lote) => {
        if (!lote?.id) return;
        const novoStatus = !(lote.ativo !== false);
        try {
            const res = await eventoService.updateLote(lote.id, { ativo: novoStatus });
            if (res.ok) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Sucesso!',
                    detail: `Lote "${lote.nome_lote}" ${novoStatus ? 'ativado' : 'inativado'} com sucesso!`,
                    life: 3000
                });
                await recarregarLotesCorrida();
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro!',
                    detail: 'Não foi possível alterar o status do lote.',
                    life: 3000
                });
            }
        } catch (err) {
            console.error("Erro ao alterar status do lote:", err);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro!',
                detail: 'Erro de comunicação ao atualizar lote.',
                life: 3000
            });
        }
    };

    const handleAbrirConfirmacaoExcluir = (lote) => {
        setLoteParaExcluir(lote);
        setDialogExcluirLote(true);
    };

    const handleConfirmarExclusaoLote = async () => {
        if (!loteParaExcluir?.id) return;
        setExcluindoLote(true);
        try {
            const res = await eventoService.deleteLote(loteParaExcluir.id);
            if (res.ok || res.status === 204 || res.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Sucesso!',
                    detail: `Lote "${loteParaExcluir.nome_lote}" excluído com sucesso!`,
                    life: 3000
                });
                setDialogExcluirLote(false);
                setLoteParaExcluir(null);
                await recarregarLotesCorrida();
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro!',
                    detail: 'Não foi possível excluir o lote.',
                    life: 3000
                });
            }
        } catch (err) {
            console.error("Erro ao excluir lote:", err);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro!',
                detail: 'Erro de comunicação ao excluir lote.',
                life: 3000
            });
        } finally {
            setExcluindoLote(false);
        }
    };

    const handleAbrirConfirmacaoExcluirInscricao = (inscricao) => {
        setInscricaoParaExcluir(inscricao);
        setDialogExcluirInscricao(true);
    };

    const handleConfirmarExclusaoInscricao = async () => {
        const inscricaoId = getInscricaoId(inscricaoParaExcluir);
        if (!inscricaoId) return;

        const corridaId = getCorridaId(dados) || inscricaoParaExcluir?.id_corrida;

        setExcluindoInscricao(true);
        try {
            const res = await incricaoService.deleteInscricao(inscricaoId);
            if (res.ok || res.status === 204 || res.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Sucesso!',
                    detail: 'Inscrição pendente excluída com sucesso!',
                    life: 3000
                });
                setDialogExcluirInscricao(false);
                setInscricaoParaExcluir(null);
                const idCorridaAtual = getCorridaId(dados);
                await carregarInscricoes(idCorridaAtual, lazyParams.page + 1, lazyParams.rows, globalFilterValue);
            } else {
                let errMsg = 'Não foi possível excluir a inscrição.';
                try {
                    const errData = await res.json();
                    errMsg = errData?.detail || errData?.erro || errMsg;
                } catch (_) {}
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro!',
                    detail: errMsg,
                    life: 3000
                });
            }
        } catch (err) {
            console.error("Erro ao excluir inscrição:", err);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro!',
                detail: 'Erro de comunicação ao excluir inscrição.',
                life: 3000
            });
        } finally {
            setExcluindoInscricao(false);
        }
    };

    const abrirModalEmail = (corrida) => {
        setCorridaEmail(corrida);
        setEmailSubject('');
        setEmailMessage('');
        setDialogEmail(true);
    };

    const fecharModalEmail = () => {
        if (enviandoEmail) return;
        setDialogEmail(false);
        setCorridaEmail(null);
        setEmailSubject('');
        setEmailMessage('');
    };

    const handleEnviarEmailMassa = async () => {
        const corridaId = getCorridaId(corridaEmail);
        if (!corridaId) return;

        if (!emailSubject.trim()) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Atenção',
                detail: 'Informe o assunto do e-mail.',
                life: 3000
            });
            return;
        }

        if (!emailMessage.trim()) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Atenção',
                detail: 'Digite o conteúdo da mensagem.',
                life: 3000
            });
            return;
        }

        setEnviandoEmail(true);
        try {
            const payload = {
                assunto: emailSubject.trim(),
                mensagem: emailMessage.trim()
            };

            const response = await eventoService.enviarEmailInscritos(corridaId, payload);
            const resData = await response.json();

            if (response.ok || response.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'E-mails Enviados!',
                    detail: resData.detail || `E-mails enviados com sucesso para os atletas inscritos.`,
                    life: 5000
                });
                fecharModalEmail();
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro ao Enviar',
                    detail: resData.detail || resData.erro || 'Falha ao disparar e-mails para os inscritos.',
                    life: 4000
                });
            }
        } catch (error) {
            console.error("Erro no envio de e-mails:", error);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro de conexão ao enviar e-mails aos inscritos.',
                life: 4000
            });
        } finally {
            setEnviandoEmail(false);
        }
    };

    const carregarCategoriasEdicao = async (corridaId) => {
        if (!corridaId) return;
        setCarregandoCategoriasEdicao(true);
        try {
            const res = await eventoService.geCategoriaPorCorrida(corridaId);
            if (res.ok) {
                const cats = await res.json();
                setCategoriasEdicao(Array.isArray(cats) ? cats : []);
            } else {
                setCategoriasEdicao([]);
            }
        } catch (err) {
            console.error("Erro ao carregar categorias na edição:", err);
            setCategoriasEdicao([]);
        } finally {
            setCarregandoCategoriasEdicao(false);
        }
    };

    const handleAdicionarCategoriaEdicao = async (e) => {
        if (e) e.preventDefault();
        const corridaId = getCorridaId(dados);
        if (!corridaId) return;

        if (!novaCategoriaNome.trim() || !novaCategoriaFaixa.trim()) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Atenção',
                detail: 'Informe o nome da categoria e a faixa etária.',
                life: 3000
            });
            return;
        }

        setSalvandoCategoria(true);
        try {
            const payload = [{
                id_corrida: parseInt(corridaId),
                categoria: novaCategoriaNome.trim(),
                faixa_etaria: novaCategoriaFaixa.trim()
            }];
            const res = await eventoService.setCategoriasEvento(JSON.stringify(payload));
            if (res.ok || res.status === 200 || res.status === 201) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Categoria adicionada com sucesso!',
                    life: 3000
                });
                setNovaCategoriaNome('');
                setNovaCategoriaFaixa('');
                await carregarCategoriasEdicao(corridaId);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Não foi possível adicionar a categoria.',
                    life: 3000
                });
            }
        } catch (err) {
            console.error("Erro ao adicionar categoria:", err);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro de comunicação ao adicionar categoria.',
                life: 3000
            });
        } finally {
            setSalvandoCategoria(false);
        }
    };

    const handleIniciarEdicaoCategoria = (cat) => {
        setEditandoCategoriaId(cat.id);
        setEditandoCategoriaNome(cat.categoria || '');
        setEditandoCategoriaFaixa(cat.faixa_etaria || '');
    };

    const handleCancelarEdicaoCategoria = () => {
        setEditandoCategoriaId(null);
        setEditandoCategoriaNome('');
        setEditandoCategoriaFaixa('');
    };

    const handleSalvarEdicaoCategoria = async (catId) => {
        if (!catId) return;
        if (!editandoCategoriaNome.trim() || !editandoCategoriaFaixa.trim()) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Atenção',
                detail: 'Informe o nome da categoria e a faixa etária.',
                life: 3000
            });
            return;
        }

        setSalvandoCategoria(true);
        try {
            const payload = {
                categoria: editandoCategoriaNome.trim(),
                faixa_etaria: editandoCategoriaFaixa.trim()
            };
            const res = await eventoService.updateCategoria(catId, payload);
            if (res.ok || res.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Categoria atualizada com sucesso!',
                    life: 3000
                });
                handleCancelarEdicaoCategoria();
                await carregarCategoriasEdicao(getCorridaId(dados));
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Não foi possível atualizar a categoria.',
                    life: 3000
                });
            }
        } catch (err) {
            console.error("Erro ao atualizar categoria:", err);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro de comunicação ao atualizar categoria.',
                life: 3000
            });
        } finally {
            setSalvandoCategoria(false);
        }
    };

    const handleRemoverCategoriaEdicao = async (catId) => {
        if (!catId) return;
        setSalvandoCategoria(true);
        try {
            const res = await eventoService.deleteCategoria(catId);
            if (res.ok || res.status === 204 || res.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Categoria removida com sucesso!',
                    life: 3000
                });
                await carregarCategoriasEdicao(getCorridaId(dados));
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Não foi possível excluir a categoria.',
                    life: 3000
                });
            }
        } catch (err) {
            console.error("Erro ao remover categoria:", err);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro de comunicação ao remover categoria.',
                life: 3000
            });
        } finally {
            setSalvandoCategoria(false);
        }
    };

    const abrirModalEditar = (evento) => {
        const toInputDate = (dateVal) => {
            if (!dateVal) return '';
            return String(dateVal).split('T')[0];
        };

        const toInputTime = (timeVal) => {
            if (!timeVal) return '';
            if (typeof timeVal === 'string' && timeVal.includes(':')) {
                return timeVal.substring(0, 5);
            }
            return '';
        };

        setDados({ ...evento });
        setEditFormData({
            nome_corrida: evento.nome_corrida || '',
            data_evento: toInputDate(evento.data_evento),
            hora_inicio_evento: toInputTime(evento.hora_inicio_evento),
            inicio_inscricao: toInputDate(evento.inicio_inscricao),
            fim_inscricao: toInputDate(evento.fim_inscricao),
            dt_entrega_kit: toInputDate(evento.dt_entrega_kit),
            cidade_evento: evento.cidade_evento || '',
            uf: evento.uf || '',
            tamanho_percurso: evento.tamanho_percurso || '',
            trajeto: evento.trajeto || '',
            qtd_vagas: evento.qtd_vagas || ''
        });
        setNovaImagem(null);
        setPreviewImagem(evento.folder || evento.imagem_url || null);
        setNovaCategoriaNome('');
        setNovaCategoriaFaixa('');
        handleCancelarEdicaoCategoria();
        setDialogEditar(true);
        carregarCategoriasEdicao(getCorridaId(evento));
    };

    const handleSelecionarImagem = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setNovaImagem(file);
            setPreviewImagem(URL.createObjectURL(file));
        }
    };

    const handleRemoverNovaImagem = () => {
        setNovaImagem(null);
        setPreviewImagem(dados?.folder || dados?.imagem_url || null);
        if (bannerInputRef.current) bannerInputRef.current.value = "";
    };

    const handleSalvarEdicao = async () => {
        const corridaId = getCorridaId(dados);
        if (!corridaId) return;

        setSalvandoEdicao(true);
        try {
            const payload = {
                nome_corrida: editFormData.nome_corrida,
                data_evento: editFormData.data_evento || null,
                hora_inicio_evento: editFormData.hora_inicio_evento ? (editFormData.hora_inicio_evento.length === 5 ? `${editFormData.hora_inicio_evento}:00` : editFormData.hora_inicio_evento) : null,
                inicio_inscricao: editFormData.inicio_inscricao || null,
                fim_inscricao: editFormData.fim_inscricao || null,
                dt_entrega_kit: editFormData.dt_entrega_kit || null,
                cidade_evento: editFormData.cidade_evento || null,
                uf: editFormData.uf || null,
                tamanho_percurso: editFormData.tamanho_percurso !== '' && editFormData.tamanho_percurso !== null ? Number(editFormData.tamanho_percurso) : null,
                trajeto: editFormData.trajeto || null,
                qtd_vagas: editFormData.qtd_vagas !== '' && editFormData.qtd_vagas !== null ? parseInt(editFormData.qtd_vagas) : null
            };

            const response = await eventoService.patchEvento(corridaId, payload);
            let responseData = null;
            try {
                responseData = await response.json();
            } catch (_) {}

            let uploadBannerSuccess = true;
            if (novaImagem) {
                try {
                    const formData = new FormData();
                    formData.append('id_corrida', corridaId);
                    formData.append('folder', novaImagem);
                    const resBanner = await eventoService.patchFolderCorrida(corridaId, formData);
                    if (!resBanner.ok && resBanner.status !== 200 && resBanner.status !== 201) {
                        uploadBannerSuccess = false;
                        console.error("Falha no upload do banner:", resBanner.status);
                    }
                } catch (errBanner) {
                    uploadBannerSuccess = false;
                    console.error("Erro no upload do banner:", errBanner);
                }
            }

            if (response.ok || response.status === 200) {
                if (!uploadBannerSuccess) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Atenção',
                        detail: 'Dados do evento atualizados, mas houve falha ao enviar a nova imagem do banner.',
                        life: 4000
                    });
                } else {
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Sucesso!',
                        detail: 'Evento atualizado com sucesso!',
                        life: 3000
                    });
                }
                setDialogEditar(false);
                await buscaEventos();
            } else {
                const erroMsg = responseData?.detail || responseData?.error || 'Erro ao atualizar o evento.';
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro',
                    detail: erroMsg,
                    life: 4000
                });
            }
        } catch (error) {
            console.error("Erro ao salvar edição:", error);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro de comunicação ao salvar evento.',
                life: 3000
            });
        } finally {
            setSalvandoEdicao(false);
        }
    };

    const exportExcel = async () => {
        const corridaId = getCorridaId(dados);
        if (!corridaId) return;

        setExportandoExcel(true);
        toast.current?.show({
            severity: 'info',
            summary: 'Exportando...',
            detail: 'Buscando todos os inscritos para gerar a planilha...',
            life: 3000
        });

        try {
            let allItems = [];
            const res = await incricaoService.getAllInscricoesPerCorrida(parseInt(corridaId));
            if (res.ok) {
                const dat = await res.json();
                const firstBatch = Array.isArray(dat)
                    ? dat
                    : Array.isArray(dat?.results)
                    ? dat.results
                    : Array.isArray(dat?.data)
                    ? dat.data
                    : Array.isArray(dat?.inscricoes)
                    ? dat.inscricoes
                    : [];
                allItems = [...firstBatch];

                // Caso o backend limite o page_size (ex: 100 por página) e haja mais registros
                const totalCount = typeof dat?.count === 'number' ? dat.count : allItems.length;
                if (firstBatch.length > 0 && allItems.length < totalCount) {
                    const pageSize = firstBatch.length;
                    const totalPagesToFetch = Math.ceil(totalCount / pageSize);
                    for (let p = 2; p <= totalPagesToFetch; p++) {
                        const pageRes = await incricaoService.getInscricaoPerCorrida(parseInt(corridaId), p, pageSize, '');
                        if (!pageRes.ok) break;
                        const pageDat = await pageRes.json();
                        const pageItems = Array.isArray(pageDat)
                            ? pageDat
                            : Array.isArray(pageDat?.results)
                            ? pageDat.results
                            : [];
                        if (pageItems.length === 0) break;
                        allItems.push(...pageItems);
                    }
                }
            }

            if (allItems.length === 0 && Array.isArray(incricoes) && incricoes.length > 0) {
                allItems = [...incricoes];
            }

            if (allItems.length === 0) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhuma inscrição encontrada para exportação.',
                    life: 3000
                });
                return;
            }

            const processedForExport = allItems.map(item => ({
                'Código Requisição': item.id_requisicao || item.id || '',
                'Nome': item.first_name || '',
                'Sobrenome': item.last_name || '',
                'Tipo Inscrição': item.is_terceiro ? 'Terceiro' : 'Titular',
                'Comprador (Titular)': item.comprador_nome || (item.is_terceiro ? '-' : `${item.first_name || ''} ${item.last_name || ''}`.trim()),
                'CPF Corredor': item.cpf_corredor || '-',
                'Telefone Corredor': item.telefone_corredor || '-',
                'Data Nascimento': item.data_nascimento_corredor ? formatDateBR(item.data_nascimento_corredor) : '-',
                'Status': item.status || '',
                'Data Inscrição': formatDateBR(item.data_inscricao),
                'Data Pagamento': formatDateBR(item.data_pagamento),
                'Método Pagamento': item.metodo_pagamento || '',
                'Voucher': item.nome_voucher || item.voucher || '-',
                'Equipe Patrocínio': item.equipe_patrocinio || '',
                'Tamanho Blusa': item.tamanho_blusa || '',
                'Categoria': item.categoria || '',
                'Faixa Etária': item.faixa_etaria || '',
                'Nº de Peito': item.num_corredor || '',
                'Kit Entregue': (item.kit_is_entregue === true || item.kit_is_entregue === 'true' || item.kit_is_entregue === 'True' || item.kit_is_entregue === 1) ? 'Sim' : 'Não'
            }));

            const xlsxModule = await import('xlsx');
            const XLSX = xlsxModule?.utils ? xlsxModule : (xlsxModule?.default || xlsxModule);

            const worksheet = XLSX.utils.json_to_sheet(processedForExport);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Inscritos');

            const nomeBase = (dados?.nome_corrida ? dados.nome_corrida.replace(/[^a-zA-Z0-9_-]/g, '_') : 'inscritos');
            const fileName = `${nomeBase}_${new Date().getTime()}.xlsx`;

            if (typeof XLSX.writeFile === 'function') {
                XLSX.writeFile(workbook, fileName, { bookType: 'xlsx' });
            } else {
                const excelBuffer = XLSX.write(workbook, {
                    bookType: 'xlsx',
                    type: 'array'
                });
                const blob = new Blob([excelBuffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setTimeout(() => window.URL.revokeObjectURL(url), 10000);
            }

            toast.current?.show({
                severity: 'success',
                summary: 'Sucesso!',
                detail: `Planilha com ${allItems.length} inscrições gerada com sucesso!`,
                life: 3000
            });
        } catch (error) {
            console.error("Erro na exportação Excel:", error);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro!',
                detail: 'Não foi possível exportar a lista de inscritos.',
                life: 3000
            });
        } finally {
            setExportandoExcel(false);
        }
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        const corridaId = getCorridaId(dados);
        if (!value.trim()) {
            setLazyParams(prev => ({ ...prev, first: 0, page: 0 }));
            carregarInscricoes(corridaId, 1, lazyParams.rows, '');
            return;
        }

        searchTimeoutRef.current = setTimeout(() => {
            setLazyParams(prev => ({ ...prev, first: 0, page: 0 }));
            carregarInscricoes(corridaId, 1, lazyParams.rows, value.trim());
        }, 400);
    };

    const handleLimparBuscaInscricoes = () => {
        setGlobalFilterValue('');
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        const corridaId = getCorridaId(dados);
        setLazyParams(prev => ({ ...prev, first: 0, page: 0 }));
        carregarInscricoes(corridaId, 1, lazyParams.rows, '');
    };

    const countTotal = data.length;
    const countAbertas = data.filter(ev => getStatusCategory(ev.status_evento) === 'abertas').length;
    const countEncerradas = data.filter(ev => getStatusCategory(ev.status_evento) === 'encerradas').length;
    const countFinalizados = data.filter(ev => getStatusCategory(ev.status_evento) === 'finalizados').length;

    const eventosFiltrados = data.filter(ev => {
        if (filtroStatus === 'todos') return true;
        if (filtroStatus === 'abertas') return getStatusCategory(ev.status_evento) === 'abertas';
        if (filtroStatus === 'encerradas') return getStatusCategory(ev.status_evento) === 'encerradas';
        if (filtroStatus === 'finalizados') return getStatusCategory(ev.status_evento) === 'finalizados';
        return true;
    });

    const renderThumbnail = (evento) => {
        const imgUrl = evento.folder || evento.imagem_url;
        return (
            <div className="w-24 h-18 sm:w-28 sm:h-20 rounded-xl overflow-hidden bg-slate-900 border border-urb-border shrink-0 flex items-center justify-center">
                {imgUrl ? (
                    <img 
                        src={imgUrl} 
                        alt={evento.nome_corrida} 
                        className="w-full h-full object-cover"
                        onError={(e) => { 
                            e.target.style.display = 'none'; 
                        }} 
                    />
                ) : (
                    <img src={escudoVerde} alt="URB RACE" className="w-10 h-10 object-contain opacity-60" />
                )}
            </div>
        );
    };

    const totalInscricoesPages = Math.ceil(totalRecords / lazyParams.rows) || 1;
    const currentInscricoesPage = lazyParams.page + 1;
    const inicioInscricaoItem = totalRecords === 0 ? 0 : lazyParams.first + 1;
    const fimInscricaoItem = Math.min(lazyParams.first + lazyParams.rows, totalRecords);

    const getPaginasVisiveisInscricoes = () => {
        const total = totalInscricoesPages;
        const current = currentInscricoesPage;
        if (total <= 7) {
            return Array.from({ length: total }, (_, i) => i + 1);
        }
        if (current <= 4) {
            return [1, 2, 3, 4, 5, '...', total];
        }
        if (current >= total - 3) {
            return [1, '...', total - 4, total - 3, total - 2, total - 1, total];
        }
        return [1, '...', current - 1, current, current + 1, '...', total];
    };

    const handleMudarPaginaInscricoes = (novaPagina, novasLinhas = lazyParams.rows) => {
        const pageIndex = novaPagina - 1;
        setLazyParams(prev => ({
            ...prev,
            rows: novasLinhas,
            page: pageIndex,
            first: pageIndex * novasLinhas
        }));
        carregarInscricoes(getCorridaId(dados), novaPagina, novasLinhas, globalFilterValue);
    };

    const abrirModalInscricaoDireta = async () => {
        const corridaId = getCorridaId(dados);
        if (!corridaId) return;
        setDialogInscricaoDireta(true);
        setEmailBusca('');
        setCorredorEncontrado(null);
        setErroBusca('');
        setCategoriaSelecionadaId('');
        setTamanhoBlusaDireta('');
        setEquipeDireta('');
        setMetodoPagamentoDireta('PIX');
        setUuidPagamentoDireta('');
        setValorPagamentoDireta(dados?.lote_ativo?.valor || dados?.valor_inscricao || '');
        setCategoriasEvento([]);
        
        try {
            const res = await eventoService.geCategoriaPorCorrida(corridaId);
            if(res.ok) {
                const cats = await res.json();
                setCategoriasEvento(Array.isArray(cats) ? cats : []);
            }
        } catch (e) {
            console.error("Erro ao buscar categorias", e);
        }
    };

    const handleBuscarCorredor = async () => {
        if (!emailBusca) return;
        setBuscandoCorredor(true);
        setErroBusca('');
        setCorredorEncontrado(null);
        
        try {
            const token = sessionStorage.getItem('brv-user-token');
            const baseUrl = eventoService.state.url.split('/core')[0];
            const res = await fetch(`${baseUrl}/core/user_credentials/?search=${encodeURIComponent(emailBusca)}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Token ${token}` : ''
                }
            });
            
            if (res.ok) {
                const data = await res.json();
                const users = Array.isArray(data) ? data : (data.results || []);
                const user = users.find(u => u.email?.toLowerCase() === emailBusca.toLowerCase() || u.username?.toLowerCase() === emailBusca.toLowerCase());
                
                if (user) {
                    setCorredorEncontrado(user);
                } else {
                    setErroBusca('Corredor não encontrado com este e-mail.');
                }
            } else {
                setErroBusca('Erro ao buscar corredor. Verifique se o e-mail está correto.');
            }
        } catch (e) {
            console.error(e);
            setErroBusca('Erro de conexão ao buscar corredor.');
        } finally {
            setBuscandoCorredor(false);
        }
    };

    const handleConfirmarInscricaoDireta = async () => {
        if (!corredorEncontrado) return;
        if (!categoriaSelecionadaId) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Selecione uma categoria.' });
            return;
        }

        setRealizandoInscricao(true);
        const corridaId = getCorridaId(dados);
        
        const hoje = new Date();
        const dataFormatada = `${hoje.getFullYear()}-${String(hoje.getMonth()+1).padStart(2,'0')}-${String(hoje.getDate()).padStart(2,'0')}`;
        
        const payload = {
            id_usuario: corredorEncontrado.id || corredorEncontrado.id_usuario,
            id_corrida: corridaId,
            id_categoria_corrida: categoriaSelecionadaId,
            tamanho_blusa: tamanhoBlusaDireta || 'Não informado',
            equipe_patrocinio: equipeDireta || '',
            status: "Inscrito",
            valor_pagamento: valorPagamentoDireta ? parseFloat(valorPagamentoDireta.toString().replace(',', '.')) : 0,
            metodo_pagamento: metodoPagamentoDireta || "INSCRIÇÃO DIRETA",
            uuid_pagamento: uuidPagamentoDireta || '',
            data_inscricao: dataFormatada
        };

        try {
            const res = await incricaoService.setNovaInscricao(JSON.stringify(payload));
            if (res.ok || res.status === 201) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Inscrição direta realizada com sucesso e e-mail enviado!',
                    life: 4000
                });
                setDialogInscricaoDireta(false);
                carregarInscricoes(corridaId, lazyParams.page + 1, lazyParams.rows, globalFilterValue);
                try {
                    const responseCount = await incricaoService.getCountInscricoesPerCorrida(corridaId);
                    const countDat = await responseCount.json();
                    setCountInscricoes(countDat || {});
                } catch (e) {}
            } else {
                const errData = await res.json();
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro',
                    detail: errData?.erro || errData?.detail || 'Não foi possível realizar a inscrição.',
                    life: 4000
                });
            }
        } catch (e) {
            console.error(e);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro de conexão ao realizar inscrição.',
                life: 4000
            });
        } finally {
            setRealizandoInscricao(false);
        }
    };

    return (
        <div className="w-full">
            <Toast ref={toast} />

            <div className="mb-6">
                <h1 className="text-2xl sm:text-3xl font-extrabold text-white uppercase tracking-wide">Meus Eventos</h1>
                <p className="text-slate-400 text-sm mt-1">
                    Gerencie seus eventos esportivos, acompanhe inscrições, lotes e configure comunicados aos atletas.
                </p>
            </div>

            {/* Filtros por status */}
            <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-6 scrollbar-none">
                {[
                    { id: 'todos', label: 'Todos', count: countTotal },
                    { id: 'abertas', label: 'Inscrições abertas', count: countAbertas },
                    { id: 'encerradas', label: 'Inscrições encerradas', count: countEncerradas },
                    { id: 'finalizados', label: 'Finalizados', count: countFinalizados },
                ].map(tab => (
                    <button
                        key={tab.id}
                        type="button"
                        onClick={() => setFiltroStatus(tab.id)}
                        className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-semibold whitespace-nowrap transition-all border ${
                            filtroStatus === tab.id
                                ? 'bg-urb-primary/10 border-urb-primary text-urb-primary shadow-neon'
                                : 'bg-urb-card border-urb-border text-slate-400 hover:text-white hover:border-slate-700'
                        }`}
                    >
                        <span>{tab.label}</span>
                        <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${
                            filtroStatus === tab.id ? 'bg-urb-primary/20 text-urb-primary' : 'bg-slate-800 text-slate-300'
                        }`}>
                            {tab.count}
                        </span>
                    </button>
                ))}
            </div>

            {aCarregar ? (
                <div className="flex flex-col items-center justify-center py-20 gap-3">
                    <Spinner size="lg" />
                    <span className="text-sm text-slate-400">Carregando eventos...</span>
                </div>
            ) : eventosFiltrados.length === 0 ? (
                <div className="bg-urb-card border border-urb-border rounded-2xl p-12 text-center text-slate-400">
                    Nenhum evento encontrado nesta categoria.
                </div>
            ) : (
                <div className="flex flex-col gap-4">
                    {eventosFiltrados.map((evento) => {
                        const corridaId = getCorridaId(evento);
                        const ehProprietario = isProprietarioCorrida(evento);
                        const isExpanded = !!expandedCards[corridaId];
                        const cat = getStatusCategory(evento.status_evento);

                        return (
                            <div key={corridaId || evento.nome_corrida} className="bg-urb-card border border-urb-border rounded-2xl p-5 shadow-lg flex flex-col gap-4 hover:border-slate-700 transition-colors">
                                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                                    <div className="flex items-center gap-4">
                                        {renderThumbnail(evento)}
                                        <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-2 flex-wrap">
                                                <h3 className="text-lg font-bold text-white m-0">
                                                    {evento.nome_corrida}
                                                </h3>
                                                {!ehProprietario && (
                                                    <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-blue-500/20 text-blue-400 border border-blue-500/30">
                                                        Co-organizador
                                                    </span>
                                                )}
                                            </div>
                                            <div className="flex items-center gap-3 text-xs text-slate-400">
                                                <span className="flex items-center gap-1">
                                                    <Calendar className="w-3.5 h-3.5 text-urb-primary" />
                                                    {formatDate(evento.data_evento)}
                                                </span>
                                                <span className="flex items-center gap-1">
                                                    <MapPin className="w-3.5 h-3.5 text-urb-primary" />
                                                    {evento.cidade_evento || 'Não informada'}{evento.uf ? ` - ${evento.uf}` : ''}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-3 self-end sm:self-center">
                                        <Badge
                                            variant={
                                                cat === 'abertas' ? 'success' : cat === 'encerradas' ? 'warning' : 'secondary'
                                            }
                                            className="text-xs"
                                        >
                                            {evento.status_evento || 'Em Preparação'}
                                        </Badge>
                                        <button
                                            type="button"
                                            onClick={() => toggleCardActions(corridaId)}
                                            className="p-2 rounded-lg bg-slate-900 border border-urb-border text-slate-400 hover:text-white transition-colors"
                                            title="Opções do evento"
                                        >
                                            {isExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                                        </button>
                                    </div>
                                </div>

                                {/* Barra de Ações Rápidas */}
                                <div className="flex flex-wrap items-center gap-2 pt-3 border-t border-urb-border">
                                    <Button
                                        size="sm"
                                        onClick={() => editProduct(evento)}
                                        className="flex items-center gap-1.5 text-xs font-bold shadow-neon px-3.5 py-2"
                                    >
                                        <Eye className="w-3.5 h-3.5" />
                                        Gerenciar Inscrições
                                    </Button>

                                    <Button
                                        variant="secondary"
                                        size="sm"
                                        onClick={() => abrirModalEditar(evento)}
                                        className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2"
                                    >
                                        <Pencil className="w-3.5 h-3.5" />
                                        Editar Evento
                                    </Button>

                                    <Button
                                        variant="secondary"
                                        size="sm"
                                        onClick={() => { setCorridaEquipe(evento); setDialogEquipe(true); }}
                                        className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2"
                                    >
                                        <Users className="w-3.5 h-3.5" />
                                        Equipe
                                    </Button>

                                    <Button
                                        variant="secondary"
                                        size="sm"
                                        onClick={() => abrirModalEmail(evento)}
                                        className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2"
                                    >
                                        <Mail className="w-3.5 h-3.5" />
                                        E-mail
                                    </Button>

                                    <Button
                                        variant="secondary"
                                        size="sm"
                                        onClick={() => { setVoucherCorridaId(corridaId); setDialogVoucher(true); }}
                                        className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2"
                                    >
                                        <Gift className="w-3.5 h-3.5" />
                                        Vouchers
                                    </Button>
                                </div>

                                {/* Ações Avançadas Expansíveis */}
                                {isExpanded && (
                                    <div className="p-3.5 rounded-xl bg-slate-900/60 border border-urb-border flex flex-wrap items-center gap-2 text-xs">
                                        <span className="font-semibold text-slate-400 mr-2">Alterar Status:</span>
                                        <button
                                            type="button"
                                            onClick={() => handleSetLiberarEvento("Inscrição Aberta", corridaId)}
                                            className="px-3 py-1.5 rounded-lg bg-green-500/20 text-green-400 hover:bg-green-500/30 font-semibold transition-colors"
                                        >
                                            Abrir Inscrições
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => handleSetLiberarEvento("Inscrição Encerrada", corridaId)}
                                            className="px-3 py-1.5 rounded-lg bg-amber-500/20 text-amber-400 hover:bg-amber-500/30 font-semibold transition-colors"
                                        >
                                            Encerrar Inscrições
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => handleSetLiberarEvento("Finalizado", corridaId)}
                                            className="px-3 py-1.5 rounded-lg bg-slate-800 text-slate-300 hover:bg-slate-700 font-semibold transition-colors"
                                        >
                                            Finalizar Evento
                                        </button>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}

            {/* Modal: Gerenciar Inscrições / Evento Completo */}
            <Modal
                isOpen={productDialog}
                onClose={() => setProductDialog(false)}
                title={dados ? `Gerenciar Evento — ${dados.nome_corrida}` : "Gerenciar Evento"}
                maxWidth="max-w-6xl"
            >
                <div className="flex flex-col gap-6 text-white">
                    {/* Header info */}
                    <div className="p-4 rounded-xl   flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                        <div className="flex items-center gap-3">
                            <h3 className="text-xl font-extrabold text-white m-0">{dados?.nome_corrida}</h3>
                            <Badge variant={dados?.status_evento === "Inscrição Aberta" ? "success" : "secondary"}>
                                {dados?.status_evento}
                            </Badge>
                        </div>
                        <div className="flex items-center gap-2">
                            <Button
                                variant="secondary"
                                size="sm"
                                onClick={() => { setCorridaEquipe(dados); setDialogEquipe(true); }}
                                className="flex items-center bg-lime-500 text-slate-800 gap-1.5 text-xs font-semibold"
                            >
                                <Users className="w-3.5 h-3.5" /> Equipe
                            </Button>
                            {dados && dados.status_evento !== "Inscrição Aberta" && (
                                <Button
                                    size="sm"
                                    onClick={() => handleSetLiberarEvento("Inscrição Aberta", getCorridaId(dados))}
                                    className="flex items-center gap-1.5 text-xs font-bold shadow-neon"
                                >
                                    <Ticket className="w-3.5 h-3.5" /> Liberar Inscrições
                                </Button>
                            )}
                        </div>
                    </div>

                    {/* Metadados Grid */}
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 rounded-xl bg-urb-card border border-urb-border text-xs">
                        <div>
                            <span className="text-slate-400 block mb-0.5">Data do Evento</span>
                            <span className="font-bold text-white text-sm">{dados ? formatDate(dados.data_evento) : '-'}</span>
                        </div>
                        <div>
                            <span className="text-slate-400 block mb-0.5">Hora do Evento</span>
                            <span className="font-bold text-white text-sm">{dados ? (dados.hora_inicio_evento || '-') : '-'}</span>
                        </div>
                        <div>
                            <span className="text-slate-400 block mb-0.5">Qtd. Vagas</span>
                            <span className="font-bold text-white text-sm">{dados?.qtd_vagas || 'Ilimitado'}</span>
                        </div>
                        <div>
                            <span className="text-slate-400 block mb-0.5">Percurso</span>
                            <span className="font-bold text-white text-sm">{dados?.tamanho_percurso ? `${dados.tamanho_percurso} KM` : '-'}</span>
                        </div>
                        <div>
                            <span className="text-slate-400 block mb-0.5">Início Inscrições</span>
                            <span className="font-bold text-white text-sm">{dados ? formatDate(dados.inicio_inscricao) : '-'}</span>
                        </div>
                        <div>
                            <span className="text-slate-400 block mb-0.5">Fim Inscrições</span>
                            <span className="font-bold text-white text-sm">{dados ? formatDate(dados.fim_inscricao) : '-'}</span>
                        </div>
                        <div>
                            <span className="text-slate-400 block mb-0.5">Entrega Kit</span>
                            <span className="font-bold text-white text-sm">{dados?.dt_entrega_kit ? formatDate(dados.dt_entrega_kit) : '-'}</span>
                        </div>
                        <div>
                            <span className="text-slate-400 block mb-0.5">Local</span>
                            <span className="font-bold text-white text-sm">{dados?.cidade_evento}{dados?.uf ? ` - ${dados.uf}` : ''}</span>
                        </div>
                    </div>

                    {/* Seção de Lotes */}
                    <div>
                        <div className="flex items-center justify-between pb-3 border-b border-urb-border mb-3">
                            <span className="font-bold text-base text-white flex items-center gap-2">
                                <Ticket className="w-4 h-4 text-urb-primary" />
                                Lotes de Inscrição ({lotes.length})
                            </span>
                            <AdicionarLote
                                corridaId={getCorridaId(dados)}
                                corridaNome={dados?.nome_corrida}
                                onLoteCriado={recarregarLotesCorrida}
                            />
                        </div>

                        {lotes.length === 0 ? (
                            <div className="p-6 rounded-xl border border-dashed border-urb-border text-center text-slate-400 text-xs">
                                Nenhum lote cadastrado para este evento.
                            </div>
                        ) : (
                            <div className="border border-urb-border rounded-xl overflow-hidden shadow-md overflow-x-auto">
                                <table className="w-full text-left text-xs">
                                    <thead className="bg-slate-900 text-slate-400 uppercase font-semibold text-[11px] border-b border-urb-border">
                                        <tr>
                                            <th className="p-3">#</th>
                                            <th className="p-3">Nome</th>
                                            <th className="p-3">Valor</th>
                                            <th className="p-3">Período</th>
                                            <th className="p-3">Vagas</th>
                                            <th className="p-3">Vendidos</th>
                                            <th className="p-3">Disponíveis</th>
                                            <th className="p-3">Status</th>
                                            <th className="p-3 text-center">Ativo</th>
                                            <th className="p-3 text-center">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-urb-border bg-urb-card">
                                        {lotes.map((lote, idx) => {
                                            const isAtivo = (lote.ativo !== false) || lote.esta_ativo;
                                            return (
                                                <tr key={lote.id || idx} className="hover:bg-slate-900/30 transition-colors">
                                                    <td className="p-3 font-semibold text-white">{lote.ordem || idx + 1}º</td>
                                                    <td className="p-3 font-bold text-white">{lote.nome_lote}</td>
                                                    <td className="p-3 font-bold text-urb-primary">
                                                        R$ {Number(lote.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </td>
                                                    <td className="p-3 text-slate-300">
                                                        {formatDate(lote.data_inicio)} até {formatDate(lote.data_fim)}
                                                    </td>
                                                    <td className="p-3 text-slate-300">{lote.qtd_vagas > 0 ? lote.qtd_vagas : 'Ilimitado'}</td>
                                                    <td className="p-3 text-white font-semibold">{lote.qtd_vendidos || 0}</td>
                                                    <td className="p-3 text-slate-300">{lote.vagas_disponiveis !== undefined && lote.vagas_disponiveis !== null ? lote.vagas_disponiveis : (lote.qtd_vagas > 0 ? lote.qtd_vagas : '—')}</td>
                                                    <td className="p-3">
                                                        <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${
                                                            lote.ativo === false
                                                                ? 'bg-red-500/20 text-red-400'
                                                                : lote.esta_ativo
                                                                    ? 'bg-urb-primary/20 text-urb-primary'
                                                                    : 'bg-slate-800 text-slate-400'
                                                        }`}>
                                                            {lote.ativo === false ? 'Desativado' : lote.esta_ativo ? 'Vigente' : 'Agendado/Fim'}
                                                        </span>
                                                    </td>
                                                    <td className="p-3 text-center">
                                                        <button
                                                            type="button"
                                                            onClick={() => handleToggleAtivoLote(lote)}
                                                            className={`text-xs font-semibold px-2 py-0.5 rounded transition-colors ${
                                                                lote.ativo !== false ? 'text-urb-primary hover:bg-urb-primary/10' : 'text-red-400 hover:bg-red-500/10'
                                                            }`}
                                                        >
                                                            {lote.ativo !== false ? 'Ativo' : 'Inativo'}
                                                        </button>
                                                    </td>
                                                    <td className="p-3 text-center">
                                                        <button
                                                            type="button"
                                                            disabled={isAtivo}
                                                            onClick={() => handleAbrirConfirmacaoExcluir(lote)}
                                                            title={isAtivo ? "Inative o lote primeiro antes de excluir" : "Excluir lote"}
                                                            className={`p-1.5 rounded transition-colors ${
                                                                isAtivo ? 'text-slate-600 cursor-not-allowed' : 'text-red-400 hover:text-red-300 hover:bg-red-500/10'
                                                            }`}
                                                        >
                                                            <Trash2 className="w-4 h-4" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    {/* Gráficos de Inscrições e Pagamento */}
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                        <div className="lg:col-span-5 p-4 rounded-xl bg-neutral-950 border border-urb-border">
                            <h4 className="font-bold text-sm text-white mb-2">Inscrições</h4>
                            <ChartInscricoes
                                inscritos={countInscricoes?.inscrito || 0}
                                vagas={dados ? dados.qtd_vagas : 0}
                            />
                        </div>
                        <div className="lg:col-span-7 p-4 rounded-xl bg-neutral-950 border border-urb-border">
                            <h4 className="font-bold text-sm text-white mb-2">Meios de Pagamento</h4>
                            <ChartMeioPagamento countMeio={countMeiosPagamento} />
                        </div>
                    </div>

                    {/* Tabela de Inscritos com Filtros e Exportação */}
                    <div className="flex flex-col gap-3">
                        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                            <h4 className="font-bold text-base text-white m-0">Lista de Inscritos</h4>
                            <div className="flex items-center gap-2 flex-wrap w-full sm:w-auto">
                                <div className="relative flex-1 sm:w-64">
                                    <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
                                    <Input
                                        value={globalFilterValue}
                                        onChange={onGlobalFilterChange}
                                        placeholder="Buscar por nome ou CPF..."
                                        className="pl-9 pr-8 py-2 text-xs"
                                    />
                                    {globalFilterValue && (
                                        <button
                                            type="button"
                                            onClick={handleLimparBuscaInscricoes}
                                            className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white p-0.5 rounded cursor-pointer transition-colors"
                                            title="Limpar pesquisa"
                                        >
                                            <X className="w-3.5 h-3.5" />
                                        </button>
                                    )}
                                </div>
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() => { setVoucherCorridaId(getCorridaId(dados)); setDialogVoucher(true); }}
                                    className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2"
                                >
                                    <Gift className="w-3.5 h-3.5 text-urb-primary" /> Vouchers
                                </Button>
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() => abrirModalEmail(dados)}
                                    className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2"
                                >
                                    <Mail className="w-3.5 h-3.5" /> Disparar E-mail
                                </Button>
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={abrirModalInscricaoDireta}
                                    className="flex items-center gap-1.5 text-xs font-semibold px-3 py-2"
                                >
                                    <Ticket className="w-3.5 h-3.5 text-green-400" /> Inscrever Corredor
                                </Button>
                                <Button
                                    size="sm"
                                    onClick={exportExcel}
                                    disabled={exportandoExcel}
                                    className="flex items-center gap-1.5 text-xs font-bold shadow-neon px-3.5 py-2"
                                >
                                    {exportandoExcel ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileSpreadsheet className="w-3.5 h-3.5" />}
                                    Excel
                                </Button>
                            </div>
                        </div>

                        <div className="border border-urb-border rounded-xl overflow-hidden shadow-md overflow-x-auto">
                            {loadingInscricoes ? (
                                <div className="flex items-center justify-center py-12">
                                    <Spinner size="md" />
                                </div>
                            ) : incricoes.length === 0 ? (
                                <div className="p-8 text-center text-slate-400 text-xs">
                                    Nenhuma inscrição encontrada para este evento.
                                </div>
                            ) : (
                                <table className="w-full text-left text-xs whitespace-nowrap">
                                    <thead className="bg-slate-900 text-slate-400 uppercase font-semibold text-[11px] border-b border-urb-border">
                                        <tr>
                                            <th className="p-3 text-center">Kit Entregue</th>
                                            <th className="p-3">Nome</th>
                                            <th className="p-3">Status</th>
                                            <th className="p-3">Inscrição</th>
                                            <th className="p-3">Pagamento</th>
                                            <th className="p-3">Método</th>
                                            <th className="p-3">Voucher</th>
                                            <th className="p-3">Equipe</th>
                                            <th className="p-3">Blusa</th>
                                            <th className="p-3">Categoria</th>
                                            <th className="p-3">Nº Peito</th>
                                            <th className="p-3">Cod. Req</th>
                                            <th className="p-3 text-center">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-urb-border bg-urb-card">
                                        {incricoes.map((item) => {
                                            const inscricaoId = getInscricaoId(item);
                                            const isChecked = selectedInscricoes.some(i => getInscricaoId(i) === inscricaoId);
                                            const pendente = isInscricaoPendente(item);
                                            return (
                                                <tr key={inscricaoId} className="hover:bg-slate-900/30 transition-colors">
                                                    <td className="p-3 text-center">
                                                        <div className="flex justify-center">
                                                            <Checkbox
                                                                checked={isChecked}
                                                                onChange={(e) => handlePatchKitEntregue(item, e.checked)}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="p-3 font-semibold text-white">
                                                        <div className="flex flex-col">
                                                            <div className="flex items-center gap-1.5 flex-wrap">
                                                                <span>{item.first_name} {item.last_name}</span>
                                                                {item.is_terceiro && (
                                                                    <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-blue-500/20 text-blue-400 border border-blue-500/30">
                                                                        Terceiro
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {item.is_terceiro && item.comprador_nome && (
                                                                <span className="text-[11px] text-slate-400 font-normal">
                                                                    Comprado por: {item.comprador_nome}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="p-3">
                                                        <Badge
                                                            variant={item.status === 'Inscrito' ? 'success' : 'warning'}
                                                            className="text-[10px]"
                                                        >
                                                            {item.status}
                                                        </Badge>
                                                    </td>
                                                    <td className="p-3 text-slate-300">{formatDate(item.data_inscricao)}</td>
                                                    <td className="p-3 text-slate-300">{formatDate(item.data_pagamento)}</td>
                                                    <td className="p-3 text-slate-300">{item.metodo_pagamento || '-'}</td>
                                                    <td className="p-3 text-slate-300">{item.nome_voucher || item.voucher || '-'}</td>
                                                    <td className="p-3 text-slate-300">{item.equipe_patrocinio || '-'}</td>
                                                    <td className="p-3 text-slate-300">{item.tamanho_blusa || '-'}</td>
                                                    <td className="p-3 text-slate-300">{item.categoria || '-'}</td>
                                                    <td className="p-3 font-mono font-bold text-urb-primary">{item.num_corredor || '-'}</td>
                                                    <td className="p-3 font-mono text-slate-400">{item.id_requisicao || item.id}</td>
                                                    <td className="p-3 text-center">
                                                        {pendente ? (
                                                            <button
                                                                type="button"
                                                                onClick={() => handleAbrirConfirmacaoExcluirInscricao(item)}
                                                                title="Excluir inscrição pendente"
                                                                aria-label={`Excluir inscrição de ${item.first_name || ''} ${item.last_name || ''}`.trim()}
                                                                className="p-1.5 rounded text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-colors cursor-pointer"
                                                            >
                                                                <Trash2 className="w-4 h-4" />
                                                            </button>
                                                        ) : (
                                                            <span className="text-slate-600">-</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        {/* Paginação da tabela de inscritos */}
                        {totalRecords > 0 && (
                            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 p-3 bg-slate-900/60 rounded-xl border border-urb-border text-xs">
                                <div className="flex flex-wrap items-center gap-2 text-slate-400">
                                    <span>
                                        Mostrando <span className="font-semibold text-white">{inicioInscricaoItem}</span> a{" "}
                                        <span className="font-semibold text-white">{fimInscricaoItem}</span> de{" "}
                                        <span className="font-semibold text-white">{totalRecords}</span> inscrições
                                    </span>
                                    <span className="text-slate-600 hidden sm:inline">|</span>
                                    <div className="flex items-center gap-1.5">
                                        <span>Exibir:</span>
                                        <select
                                            value={lazyParams.rows}
                                            onChange={(e) => handleMudarPaginaInscricoes(1, Number(e.target.value))}
                                            className="bg-slate-950 border border-urb-border text-white text-xs rounded-lg px-2 py-1 focus:outline-none focus:border-urb-primary transition-colors cursor-pointer"
                                        >
                                            <option value={10}>10</option>
                                            <option value={15}>15</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>
                                    </div>
                                </div>

                                {totalInscricoesPages > 1 && (
                                    <div className="flex items-center gap-1">
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            disabled={currentInscricoesPage === 1}
                                            onClick={() => handleMudarPaginaInscricoes(1)}
                                            className="p-1.5 h-8 w-8 text-slate-400 hover:text-white"
                                            title="Primeira página"
                                        >
                                            <ChevronsLeft className="w-4 h-4" />
                                        </Button>

                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            disabled={currentInscricoesPage === 1}
                                            onClick={() => handleMudarPaginaInscricoes(currentInscricoesPage - 1)}
                                            className="p-1.5 h-8 w-8 text-slate-400 hover:text-white"
                                            title="Página anterior"
                                        >
                                            <ChevronLeft className="w-4 h-4" />
                                        </Button>

                                        {getPaginasVisiveisInscricoes().map((pg, idx) =>
                                            pg === '...' ? (
                                                <span key={`dots-${idx}`} className="w-7 h-8 flex items-center justify-center text-slate-500 font-bold select-none text-xs">
                                                    ...
                                                </span>
                                            ) : (
                                                <button
                                                    key={pg}
                                                    type="button"
                                                    onClick={() => handleMudarPaginaInscricoes(pg)}
                                                    className={`w-7 h-7 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center text-xs font-semibold transition-colors cursor-pointer border ${
                                                        pg === currentInscricoesPage
                                                            ? "bg-urb-primary text-black border-urb-primary font-bold shadow-neon"
                                                            : "bg-slate-950 border-urb-border text-slate-300 hover:text-white hover:border-urb-primary/40"
                                                    }`}
                                                >
                                                    {pg}
                                                </button>
                                            )
                                        )}

                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            disabled={currentInscricoesPage === totalInscricoesPages}
                                            onClick={() => handleMudarPaginaInscricoes(currentInscricoesPage + 1)}
                                            className="p-1.5 h-8 w-8 text-slate-400 hover:text-white"
                                            title="Próxima página"
                                        >
                                            <ChevronRight className="w-4 h-4" />
                                        </Button>

                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            disabled={currentInscricoesPage === totalInscricoesPages}
                                            onClick={() => handleMudarPaginaInscricoes(totalInscricoesPages)}
                                            className="p-1.5 h-8 w-8 text-slate-400 hover:text-white"
                                            title="Última página"
                                        >
                                            <ChevronsRight className="w-4 h-4" />
                                        </Button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </Modal>

            {/* Modal: Editar Corrida */}
            <Modal
                isOpen={dialogEditar}
                onClose={() => setDialogEditar(false)}
                title="Editar Corrida"
                maxWidth="max-w-3xl"
            >
                <div className="flex flex-col gap-4 text-white">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div className="sm:col-span-2">
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Nome da Corrida</label>
                            <Input
                                value={editFormData.nome_corrida}
                                onChange={(e) => setEditFormData({ ...editFormData, nome_corrida: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Qtd. Vagas</label>
                            <Input
                                type="number"
                                min="0"
                                value={editFormData.qtd_vagas}
                                onChange={(e) => setEditFormData({ ...editFormData, qtd_vagas: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Data do Evento</label>
                            <Input
                                type="date"
                                value={editFormData.data_evento}
                                onChange={(e) => setEditFormData({ ...editFormData, data_evento: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Hora Início</label>
                            <Input
                                type="time"
                                value={editFormData.hora_inicio_evento}
                                onChange={(e) => setEditFormData({ ...editFormData, hora_inicio_evento: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Percurso (KM)</label>
                            <Input
                                type="number"
                                step="0.1"
                                value={editFormData.tamanho_percurso}
                                onChange={(e) => setEditFormData({ ...editFormData, tamanho_percurso: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Início das Inscrições</label>
                            <Input
                                type="date"
                                value={editFormData.inicio_inscricao}
                                onChange={(e) => setEditFormData({ ...editFormData, inicio_inscricao: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Fim das Inscrições</label>
                            <Input
                                type="date"
                                value={editFormData.fim_inscricao}
                                onChange={(e) => setEditFormData({ ...editFormData, fim_inscricao: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Data Entrega Kit</label>
                            <Input
                                type="date"
                                value={editFormData.dt_entrega_kit}
                                onChange={(e) => setEditFormData({ ...editFormData, dt_entrega_kit: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Cidade</label>
                            <Input
                                value={editFormData.cidade_evento}
                                onChange={(e) => setEditFormData({ ...editFormData, cidade_evento: e.target.value })}
                            />
                        </div>

                        <div className="sm:col-span-2">
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Trajeto / Observações</label>
                            <Textarea
                                rows={3}
                                value={editFormData.trajeto}
                                onChange={(e) => setEditFormData({ ...editFormData, trajeto: e.target.value })}
                            />
                        </div>

                        {/* Banner Upload */}
                        <div className="sm:col-span-2">
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">Banner do Evento</label>
                            <input
                                type="file"
                                ref={bannerInputRef}
                                accept="image/*"
                                className="hidden"
                                onChange={handleSelecionarImagem}
                            />
                            <div className="p-3 rounded-xl bg-slate-900 border border-urb-border flex items-center justify-between gap-4">
                                {previewImagem && (
                                    <img
                                        src={previewImagem}
                                        alt="Banner Preview"
                                        className="w-32 h-16 object-cover rounded-lg border border-urb-border"
                                    />
                                )}
                                <div className="flex items-center gap-2">
                                    <Button
                                        type="button"
                                        variant="secondary"
                                        size="sm"
                                        onClick={() => bannerInputRef.current && bannerInputRef.current.click()}
                                        className="flex items-center gap-1.5 text-xs font-semibold"
                                    >
                                        <Upload className="w-3.5 h-3.5" />
                                        {previewImagem ? "Alterar Banner" : "Upload Banner"}
                                    </Button>
                                    {novaImagem && (
                                        <Button
                                            type="button"
                                            variant="danger"
                                            size="sm"
                                            onClick={handleRemoverNovaImagem}
                                            className="text-xs font-semibold"
                                        >
                                            Desfazer
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Mapa do Percurso (Google Maps) */}
                        {getCorridaId(dados) && (
                            <div className="sm:col-span-2 pt-2 border-t border-urb-border">
                                <UploadTrajetoMaps
                                    key={getCorridaId(dados)}
                                    idCorrida={getCorridaId(dados)}
                                    trajetoAtual={dados?.trajeto_mapa}
                                    onTrajetoAtualizado={(novoTrajeto) => {
                                        setDados(prev => ({ ...prev, trajeto_mapa: novoTrajeto }));
                                        setData(prev => prev.map(ev => getCorridaId(ev) === getCorridaId(dados) ? { ...ev, trajeto_mapa: novoTrajeto } : ev));
                                    }}
                                />
                            </div>
                        )}

                        {/* Gerenciamento de Categorias */}
                        <div className="sm:col-span-2 pt-2 border-t border-urb-border">
                            <div className="flex items-center justify-between mb-3">
                                <label className="text-xs font-bold text-white flex items-center gap-1.5 uppercase tracking-wider">
                                    <Award className="w-4 h-4 text-urb-primary" />
                                    Categorias da Corrida ({categoriasEdicao.length})
                                </label>
                                {carregandoCategoriasEdicao && (
                                    <span className="text-[11px] text-slate-400 flex items-center gap-1">
                                        <Loader2 className="w-3 h-3 animate-spin" /> Carregando categorias...
                                    </span>
                                )}
                            </div>

                            {/* Formulário de Adicionar Nova Categoria */}
                            <div className="grid grid-cols-1 sm:grid-cols-12 gap-2.5 items-end p-3 rounded-xl bg-slate-900/80 border border-urb-border mb-3">
                                <div className="sm:col-span-5">
                                    <label className="text-[11px] font-semibold text-slate-400 mb-1 block">Nome da Categoria</label>
                                    <Input
                                        value={novaCategoriaNome}
                                        onChange={(e) => setNovaCategoriaNome(e.target.value)}
                                        placeholder="Ex.: Geral 5K, 10K, etc."
                                        className="text-xs py-1.5"
                                        disabled={salvandoCategoria}
                                    />
                                </div>
                                <div className="sm:col-span-4">
                                    <div className="flex items-center justify-between mb-1">
                                        <label className="text-[11px] font-semibold text-slate-400 block">Faixa Etária</label>
                                        <button
                                            type="button"
                                            onClick={() => setNovaCategoriaFaixa("60+")}
                                            className="text-[10px] text-urb-primary hover:underline cursor-pointer"
                                            title="Preencher com 60+ (aplica 50% de desconto automático)"
                                        >
                                            + Usar 60+
                                        </button>
                                    </div>
                                    <Input
                                        value={novaCategoriaFaixa}
                                        onChange={(e) => setNovaCategoriaFaixa(e.target.value)}
                                        placeholder="Ex.: 18 a 29 anos, 60+, Livre"
                                        className="text-xs py-1.5"
                                        disabled={salvandoCategoria}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleAdicionarCategoriaEdicao();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="sm:col-span-3">
                                    <Button
                                        type="button"
                                        onClick={handleAdicionarCategoriaEdicao}
                                        disabled={salvandoCategoria || !novaCategoriaNome.trim() || !novaCategoriaFaixa.trim()}
                                        className="w-full text-xs font-bold py-1.5 shadow-neon flex items-center justify-center gap-1.5"
                                    >
                                        {salvandoCategoria && !editandoCategoriaId ? (
                                            <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                        ) : (
                                            <Plus className="w-3.5 h-3.5" />
                                        )}
                                        Adicionar
                                    </Button>
                                </div>
                            </div>

                            {/* Lista de Categorias Cadastradas */}
                            <div className="space-y-2 max-h-56 overflow-y-auto pr-1">
                                {categoriasEdicao.length === 0 && !carregandoCategoriasEdicao ? (
                                    <div className="p-4 rounded-xl border border-dashed border-urb-border text-center text-slate-500 text-xs">
                                        Nenhuma categoria cadastrada para esta corrida.
                                    </div>
                                ) : (
                                    categoriasEdicao.map((cat) => {
                                        const emEdicao = editandoCategoriaId === cat.id;

                                        if (emEdicao) {
                                            return (
                                                <div
                                                    key={cat.id}
                                                    className="p-2.5 rounded-lg bg-slate-900 border border-urb-primary/50 flex flex-col sm:flex-row items-stretch sm:items-center gap-2"
                                                >
                                                    <div className="flex-1">
                                                        <Input
                                                            value={editandoCategoriaNome}
                                                            onChange={(e) => setEditandoCategoriaNome(e.target.value)}
                                                            placeholder="Nome da categoria"
                                                            className="text-xs py-1"
                                                            disabled={salvandoCategoria}
                                                        />
                                                    </div>
                                                    <div className="flex-1">
                                                        <Input
                                                            value={editandoCategoriaFaixa}
                                                            onChange={(e) => setEditandoCategoriaFaixa(e.target.value)}
                                                            placeholder="Faixa etária"
                                                            className="text-xs py-1"
                                                            disabled={salvandoCategoria}
                                                        />
                                                    </div>
                                                    <div className="flex items-center gap-1.5 justify-end">
                                                        <Button
                                                            type="button"
                                                            size="sm"
                                                            onClick={() => handleSalvarEdicaoCategoria(cat.id)}
                                                            disabled={salvandoCategoria}
                                                            className="text-xs px-2.5 py-1 font-bold shadow-neon flex items-center gap-1"
                                                        >
                                                            {salvandoCategoria ? <Loader2 className="w-3 h-3 animate-spin" /> : <CheckCircle2 className="w-3 h-3" />}
                                                            Salvar
                                                        </Button>
                                                        <Button
                                                            type="button"
                                                            variant="secondary"
                                                            size="sm"
                                                            onClick={handleCancelarEdicaoCategoria}
                                                            disabled={salvandoCategoria}
                                                            className="text-xs px-2 py-1"
                                                        >
                                                            Cancelar
                                                        </Button>
                                                    </div>
                                                </div>
                                            );
                                        }

                                        return (
                                            <div
                                                key={cat.id}
                                                className="p-2.5 rounded-lg bg-slate-900/60 border border-urb-border hover:border-slate-700 flex items-center justify-between gap-3 text-xs transition-colors"
                                            >
                                                <div className="flex items-center gap-2 min-w-0 flex-wrap">
                                                    <Tag className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                                                    <span className="font-semibold text-white truncate">{cat.categoria}</span>
                                                    <span className="text-slate-400 shrink-0">({cat.faixa_etaria})</span>
                                                    {isFaixaEtaria60Mais(cat.faixa_etaria) && (
                                                        <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-400 border border-emerald-500/30">
                                                            50% OFF 60+
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="flex items-center gap-1 shrink-0">
                                                    <button
                                                        type="button"
                                                        onClick={() => handleIniciarEdicaoCategoria(cat)}
                                                        disabled={salvandoCategoria}
                                                        title="Editar categoria"
                                                        className="p-1.5 text-slate-400 hover:text-white rounded hover:bg-slate-800 transition-colors"
                                                    >
                                                        <Pencil className="w-3.5 h-3.5" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoverCategoriaEdicao(cat.id)}
                                                        disabled={salvandoCategoria}
                                                        title="Excluir categoria"
                                                        className="p-1.5 text-red-400 hover:text-red-300 rounded hover:bg-red-500/10 transition-colors"
                                                    >
                                                        <Trash2 className="w-3.5 h-3.5" />
                                                    </button>
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end gap-2.5 pt-4 border-t border-urb-border">
                        <Button
                            variant="secondary"
                            onClick={() => setDialogEditar(false)}
                            disabled={salvandoEdicao}
                            className="px-4 py-2 text-xs"
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleSalvarEdicao}
                            disabled={salvandoEdicao}
                            className="px-6 py-2 text-xs font-bold shadow-neon flex items-center gap-1.5"
                        >
                            {salvandoEdicao ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-4 h-4" />}
                            Salvar Alterações
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Modal: Disparo de E-mail */}
            <Modal
                isOpen={dialogEmail}
                onClose={fecharModalEmail}
                title="Disparo de E-mail aos Inscritos"
                maxWidth="max-w-2xl"
            >
                <div className="flex flex-col gap-4 text-white">
                    {corridaEmail && (
                        <div className="p-3.5 rounded-xl bg-slate-900 border-l-4 border-urb-primary border border-urb-border">
                            <h4 className="font-bold text-sm text-urb-primary m-0">{corridaEmail.nome_corrida}</h4>
                            <p className="text-xs text-slate-400 mt-0.5 m-0">
                                O comunicado será enviado diretamente para o e-mail de todos os atletas confirmados/inscritos nesta corrida.
                            </p>
                        </div>
                    )}

                    <div>
                        <label className="text-xs font-semibold text-slate-300 mb-1 block">
                            Assunto do E-mail <span className="text-red-400">*</span>
                        </label>
                        <Input
                            value={emailSubject}
                            onChange={(e) => setEmailSubject(e.target.value)}
                            placeholder="Ex: Comunicado Importante - Horário de Largada e Entrega de Kits"
                            disabled={enviandoEmail}
                        />
                    </div>

                    <div>
                        <label className="text-xs font-semibold text-slate-300 mb-1 block">
                            Mensagem <span className="text-red-400">*</span>
                        </label>
                        <Textarea
                            value={emailMessage}
                            onChange={(e) => setEmailMessage(e.target.value)}
                            rows={8}
                            placeholder="Digite o texto da mensagem que será disparada para os inscritos..."
                            disabled={enviandoEmail}
                        />
                        <span className="text-[11px] text-slate-400 mt-1 block">
                            As quebras de linha e parágrafos serão formatados no layout de e-mail da Urbrace.
                        </span>
                    </div>

                    <div className="flex justify-end gap-2.5 pt-4 border-t border-urb-border">
                        <Button
                            variant="secondary"
                            onClick={fecharModalEmail}
                            disabled={enviandoEmail}
                            className="px-4 py-2 text-xs"
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleEnviarEmailMassa}
                            disabled={enviandoEmail}
                            className="px-6 py-2 text-xs font-bold shadow-neon flex items-center gap-1.5"
                        >
                            {enviandoEmail ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                            Disparar E-mails
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Modal: Excluir Lote Confirmação */}
            <Modal
                isOpen={dialogExcluirLote}
                onClose={() => !excluindoLote && setDialogExcluirLote(false)}
                title="Excluir Lote"
                maxWidth="max-w-md"
            >
                <div className="flex flex-col items-center text-center gap-3 py-2 text-white">
                    <div className="w-14 h-14 rounded-full bg-red-500/15 text-red-500 flex items-center justify-center">
                        <Trash2 className="w-7 h-7" />
                    </div>

                    <h4 className="font-bold text-lg text-white m-0">
                        Tem certeza que deseja excluir este lote?
                    </h4>

                    {loteParaExcluir && (
                        <div className="p-3 rounded-lg bg-slate-900 border-l-4 border-red-500 border border-urb-border w-full text-left">
                            <div className="font-bold text-sm text-white">
                                {loteParaExcluir.nome_lote}
                            </div>
                            <div className="text-xs text-slate-400 mt-0.5">
                                Valor: R$ {Number(loteParaExcluir.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </div>
                        </div>
                    )}

                    <p className="text-xs text-slate-400 m-0">
                        Esta ação é irreversível. O lote será removido permanentemente da corrida.
                    </p>

                    <div className="flex justify-end gap-2 w-full mt-4 pt-3 border-t border-urb-border">
                        <Button
                            variant="secondary"
                            onClick={() => setDialogExcluirLote(false)}
                            disabled={excluindoLote}
                            className="text-xs px-4"
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="danger"
                            onClick={handleConfirmarExclusaoLote}
                            disabled={excluindoLote}
                            className="text-xs px-4 font-bold flex items-center gap-1.5"
                        >
                            {excluindoLote ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Trash2 className="w-3.5 h-3.5" />}
                            Excluir Lote
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Modal: Excluir Inscrição Pendente Confirmação */}
            <Modal
                isOpen={dialogExcluirInscricao}
                onClose={() => !excluindoInscricao && setDialogExcluirInscricao(false)}
                title="Excluir Inscrição"
                maxWidth="max-w-md"
            >
                <div className="flex flex-col items-center text-center gap-3 py-2 text-white">
                    <div className="w-14 h-14 rounded-full bg-red-500/15 text-red-500 flex items-center justify-center">
                        <Trash2 className="w-7 h-7" />
                    </div>

                    <h4 className="font-bold text-lg text-white m-0">
                        Tem certeza que deseja excluir esta inscrição?
                    </h4>

                    {inscricaoParaExcluir && (
                        <div className="p-3 rounded-lg bg-slate-900 border-l-4 border-red-500 border border-urb-border w-full text-left">
                            <div className="font-bold text-sm text-white">
                                {inscricaoParaExcluir.first_name} {inscricaoParaExcluir.last_name}
                            </div>
                            <div className="text-xs text-slate-400 mt-0.5">
                                Status: {inscricaoParaExcluir.status} | ID: {getInscricaoId(inscricaoParaExcluir)}{inscricaoParaExcluir.id_requisicao ? ` (Req: ${inscricaoParaExcluir.id_requisicao})` : ''}
                            </div>
                        </div>
                    )}

                    <p className="text-xs text-slate-400 m-0">
                        Esta ação é irreversível. A inscrição pendente será removida permanentemente.
                    </p>

                    <div className="flex justify-end gap-2 w-full mt-4 pt-3 border-t border-urb-border">
                        <Button
                            variant="secondary"
                            onClick={() => setDialogExcluirInscricao(false)}
                            disabled={excluindoInscricao}
                            className="text-xs px-4"
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="danger"
                            onClick={handleConfirmarExclusaoInscricao}
                            disabled={excluindoInscricao}
                            className="text-xs px-4 font-bold flex items-center gap-1.5"
                        >
                            {excluindoInscricao ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Trash2 className="w-3.5 h-3.5" />}
                            Excluir Inscrição
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Modal: Vouchers */}
            <Modal
                isOpen={dialogVoucher}
                onClose={() => { setDialogVoucher(false); setVoucherCorridaId(null); }}
                title="Gerenciar Vouchers"
                maxWidth="max-w-4xl"
            >
                <Voucher corridaId={voucherCorridaId} onClose={() => { setDialogVoucher(false); setVoucherCorridaId(null); }} />
            </Modal>

            {/* Modal: Equipe / Co-organizadores */}
            <Modal
                isOpen={dialogEquipe}
                onClose={() => { setDialogEquipe(false); setCorridaEquipe(null); }}
                title="Gerenciamento de Equipe / Co-organizadores"
                maxWidth="max-w-3xl"
            >
                {corridaEquipe && (
                    <GerenciarCoOrganizadores
                        corridaId={getCorridaId(corridaEquipe)}
                        corridaNome={corridaEquipe.nome_corrida}
                        isProprietario={isProprietarioCorrida(corridaEquipe)}
                        onClose={() => { setDialogEquipe(false); setCorridaEquipe(null); }}
                    />
                )}
            </Modal>

            {/* Modal: Inscrição Direta */}
            <Modal
                isOpen={dialogInscricaoDireta}
                onClose={() => setDialogInscricaoDireta(false)}
                title="Inscrição Direta"
                maxWidth="max-w-xl"
            >
                <div className="flex flex-col gap-4 text-white">
                    <p className="text-sm text-slate-400 m-0">
                        Inscreva um corredor manualmente apenas registrando o id do pagamento. O e-mail de confirmação será enviado automaticamente.
                    </p>

                    <div className="flex gap-2 items-end">
                        <div className="flex-1">
                            <label className="text-xs font-semibold text-slate-300 mb-1 block">E-mail do Corredor</label>
                            <Input
                                type="email"
                                value={emailBusca}
                                onChange={(e) => setEmailBusca(e.target.value)}
                                placeholder="exemplo@email.com"
                                onKeyDown={(e) => { if(e.key === 'Enter') handleBuscarCorredor(); }}
                            />
                        </div>
                        <Button
                            variant="secondary"
                            onClick={handleBuscarCorredor}
                            disabled={buscandoCorredor || !emailBusca}
                            className="px-4 py-2 text-xs h-[42px] flex items-center justify-center"
                        >
                            {buscandoCorredor ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />}
                        </Button>
                    </div>
                    {erroBusca && <span className="text-red-400 text-xs font-semibold">{erroBusca}</span>}

                    {corredorEncontrado && (
                        <div className="p-4 rounded-xl bg-lime-600 border border-urb-border flex flex-col gap-3">
                            <div>
                                <span className="block text-xs text-slate-800">Corredor Localizado:</span>
                                <span className="block font-bold text-black text-base">
                                    {corredorEncontrado.first_name} {corredorEncontrado.last_name}
                                </span>
                                <span className="block text-xs text-black mt-0.5">{corredorEncontrado.email}</span>
                            </div>

                            <div className="h-px w-full bg-urb-border my-1"></div>

                            <div>
                                <label className="text-xs font-semibold text-slate-800 mb-1 block">Categoria <span className="text-red-400">*</span></label>
                                <select
                                    value={categoriaSelecionadaId}
                                    onChange={(e) => {
                                        const novoId = e.target.value;
                                        setCategoriaSelecionadaId(novoId);
                                        const catObj = categoriasEvento.find(c => String(c.id) === String(novoId));
                                        const baseValor = parseFloat(dados?.lote_ativo?.valor || dados?.valor_inscricao || 0);
                                        if (catObj && isFaixaEtaria60Mais(catObj.faixa_etaria) && baseValor > 0) {
                                            setValorPagamentoDireta(calcularValorComDesconto60Mais(baseValor, catObj.faixa_etaria).toFixed(2));
                                        } else if (baseValor > 0) {
                                            setValorPagamentoDireta(baseValor.toFixed(2));
                                        }
                                    }}
                                    className="w-full bg-neutral-900 border border-urb-border rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-urb-primary transition-colors"
                                >
                                    <option value="">Selecione a categoria</option>
                                    {categoriasEvento.map(cat => (
                                        <option key={cat.id} value={cat.id}>
                                            {cat.categoria}{cat.faixa_etaria ? ` (${cat.faixa_etaria})` : ''}{isFaixaEtaria60Mais(cat.faixa_etaria) ? ' — 50% OFF (60+)' : ''}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <label className="text-xs font-semibold text-slate-800 mb-1 block">Tamanho da Blusa</label>
                                    <select
                                        value={tamanhoBlusaDireta}
                                        onChange={(e) => setTamanhoBlusaDireta(e.target.value)}
                                        className="w-full bg-neutral-900 border border-urb-border rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-urb-primary transition-colors"
                                    >
                                        <option value="">Opcional</option>
                                        {['PP', 'P', 'M', 'G', 'GG', 'XG', 'Tamanho Único'].map(tam => (
                                            <option key={tam} value={tam}>{tam}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="text-xs font-semibold text-slate-800 mb-1 block">Equipe/Assessoria</label>
                                    <Input
                                        value={equipeDireta}
                                        onChange={(e) => setEquipeDireta(e.target.value)}
                                        placeholder="Opcional"
                                        className="py-2 text-sm"
                                    />
                                </div>
                            </div>

                            <div className="h-px w-full bg-urb-border my-1"></div>

                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                                <div>
                                    <label className="text-xs font-semibold text-slate-800 mb-1 block">Valor Inscrição (R$)</label>
                                    <Input
                                        type="number"
                                        step="0.01"
                                        value={valorPagamentoDireta}
                                        onChange={(e) => setValorPagamentoDireta(e.target.value)}
                                        placeholder="0.00"
                                        className="py-2 text-sm"
                                    />
                                </div>
                                <div>
                                    <label className="text-xs font-semibold text-slate-800 mb-1 block">Tipo de Pagamento</label>
                                    <select
                                        value={metodoPagamentoDireta}
                                        onChange={(e) => setMetodoPagamentoDireta(e.target.value)}
                                        className="w-full bg-neutral-900 border border-urb-border rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-urb-primary transition-colors"
                                    >
                                        <option value="PIX">PIX</option>
                                        <option value="Cartão de Crédito">Cartão de Crédito</option>
                                        <option value="Boleto">Boleto</option>
                                        <option value="Dinheiro">Dinheiro</option>
                                        <option value="Cortesia">Cortesia</option>
                                        <option value="Permuta">Permuta</option>
                                        <option value="INSCRIÇÃO DIRETA">INSCRIÇÃO DIRETA</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="text-xs font-semibold text-slate-800 mb-1 block">UUID do Pagamento</label>
                                    <Input
                                        value={uuidPagamentoDireta}
                                        onChange={(e) => setUuidPagamentoDireta(e.target.value)}
                                        placeholder="Opcional"
                                        className="py-2 text-sm"
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="flex justify-end gap-2.5 pt-4 border-t border-urb-border mt-2">
                        <Button
                            variant="secondary"
                            onClick={() => setDialogInscricaoDireta(false)}
                            disabled={realizandoInscricao}
                            className="px-4 py-2 text-xs"
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleConfirmarInscricaoDireta}
                            disabled={realizandoInscricao || !corredorEncontrado || !categoriaSelecionadaId}
                            className="px-6 py-2 text-xs font-bold shadow-neon flex items-center gap-1.5 bg-green-500 hover:bg-green-600 text-white border-none"
                        >
                            {realizandoInscricao ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-4 h-4" />}
                            Confirmar Inscrição
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default ListaEventos;
